import type { SVGProps } from "react";
const SvgHandBag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <defs>
      <linearGradient
        id="handBag_svg__c"
        x1={15.997}
        x2={15.997}
        y1={6.945}
        y2={25.909}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2f9e5f" />
        <stop offset={1} stopColor="#006739" />
      </linearGradient>
      <clipPath id="handBag_svg__b">
        <path fill="#fff" d="M2.97 3h26v26h-26z" />
      </clipPath>
      <filter
        id="handBag_svg__a"
        width={19.335}
        height={3.808}
        x={6.302}
        y={26.309}
        filterUnits="userSpaceOnUse"
      >
        <feGaussianBlur stdDeviation={0.75} />
      </filter>
    </defs>
    <g filter="url(#handBag_svg__a)" opacity={0.8}>
      <ellipse cx={15.969} cy={28.213} fill="#000" rx={8.168} ry={0.404} />
    </g>
    <g clipPath="url(#handBag_svg__b)">
      <path
        fill="#00532D"
        d="M7.856 25.91a2.315 2.315 0 0 0 2.326 2.303H21.81a2.315 2.315 0 0 0 2.326-2.304v-1.08H7.855zm13.94-14.191s1.675-3.062 1.105-4.543l1.141-1.073h.916c.852 2.648-1.482 7.344-1.482 7.344z"
      />
      <path
        fill="#057B44"
        d="M21.95 9.957h-2.325c0-3.553 1.638-4.84 3.3-4.84 1.21 0 2.035.983 2.035.983-.96 0-3.01 1.549-3.01 3.857"
      />
      <path
        fill="#00532D"
        d="M10.22 11.719S8.547 8.657 9.118 7.176L7.975 6.103H7.06c-.852 2.648 1.482 7.343 1.482 7.343z"
      />
      <path
        fill="#057B44"
        d="M10.071 9.77h2.326c0-3.553-1.639-4.652-3.3-4.652-1.211 0-2.036.982-2.036.982.961 0 3.01 1.362 3.01 3.67"
      />
      <path
        fill="#00532D"
        d="M8.736 25.106H7.12a1.287 1.287 0 0 1-1.293-1.28v-4.927c0-.708.579-1.281 1.293-1.281h1.614zm14.533 0h1.614c.714 0 1.293-.573 1.293-1.28v-4.927c0-.708-.579-1.281-1.293-1.281h-1.614z"
      />
      <path
        fill="url(#handBag_svg__c)"
        d="M24.137 25.909H7.857V13.68c0-3.72 3.044-6.736 6.8-6.736h2.68c3.755 0 6.8 3.016 6.8 6.736z"
      />
      <path
        fill="#0AB062"
        d="M10.592 20.125a2 2 0 0 1 2-2h6.538a2 2 0 0 1 2 2v3.599a.5.5 0 0 1-.5.5h-9.538a.5.5 0 0 1-.5-.5z"
      />
      <path
        fill="#00532D"
        d="M20.63 23.923v.3h-9.538v-.3zm.2-.2v-3.598a1.7 1.7 0 0 0-1.7-1.7h-6.538a1.7 1.7 0 0 0-1.7 1.7v3.598c0 .11.09.2.2.2v.3a.5.5 0 0 1-.5-.5v-3.598a2 2 0 0 1 1.796-1.99l.204-.01h6.537a2 2 0 0 1 2 2v3.598a.5.5 0 0 1-.5.5v-.3a.2.2 0 0 0 .2-.2"
        opacity={0.4}
      />
      <path
        fill="#54C891"
        d="M23.267 16.776h-.581V13.86c0-3.017-2.478-5.472-5.524-5.472h-2.325c-3.046 0-5.524 2.455-5.524 5.472v2.916H8.73V13.86c0-3.335 2.74-6.048 6.106-6.048h2.325c3.367 0 6.105 2.713 6.105 6.048z"
        opacity={0.6}
      />
      <path
        fill="#fff"
        d="m18.499 12.92-1.878-1.86a.89.89 0 0 0-1.251 0l-1.878 1.86a.87.87 0 0 0 0 1.24l1.878 1.86a.89.89 0 0 0 1.251 0l1.878-1.86a.87.87 0 0 0 0-1.24m-3 1.495a.415.415 0 0 1-.417.414.415.415 0 0 1-.417-.414v-1.751c0-.229.187-.414.417-.414.231 0 .417.185.417.414zm1.789 0a.415.415 0 0 1-.417.414.415.415 0 0 1-.417-.414v-1.751c0-.229.186-.414.417-.414s.417.185.417.414z"
      />
    </g>
  </svg>
);
export default SvgHandBag;
